/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { Injectable } from '@angular/core';
import { ApiService, SoftwareVersionResponse } from '@midas/shared/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch, pessimisticUpdate } from '@nrwl/angular';
import { map } from 'rxjs';
import * as SoftwareVersionActions from './software-versions.actions';

@Injectable()
export class SoftwareVersionsEffects {
  readonly getSoftwareVersions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoftwareVersionActions.getSoftwareVersions),
      fetch({
        id: () => true,
        run: () => {
          return this.api.get<SoftwareVersionResponse>('/software-version').pipe(
            map((res) => {
              const versions = res.items;
              return SoftwareVersionActions.getSoftwareVersionSuccess({ versions });
            }),
          );
        },
        onError: (action, error) => {
          return SoftwareVersionActions.getSoftwareVersionError({ error, showInDialog: true });
        },
      }),
    ),
  );

  readonly deleteSoftwareVersion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoftwareVersionActions.deleteVersion),
      pessimisticUpdate({
        run: ({ version }) =>
          this.api.delete<{ id: number }>(`/software-version/${version.id}`).pipe(
            map(() => {
              return SoftwareVersionActions.deleteVersionSuccess({ deletedVersionId: version.id });
            }),
          ),
        onError: (action, error) => {
          return SoftwareVersionActions.deleteSoftwareVersionError({ error });
        },
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {}
}
